<template>
  <div class="wrap">
    <div class="container lnb">
      <div class="contents_wrap">
        <div class="contents">
          <div class="title">
            {{ title }}
            <el-button class="title_btn" type="primary" size="" @click="addBtn()">등록</el-button>
            <div class="clear"></div>
          </div>
          <div class="table_wrap">
            <div class="table_search">
              <el-select
                v-model="tableSelected"
                placeholder="Select"
                class="table_s_select"
              >
                <el-option
                  v-for="item in tableSelectOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-input class="table_s_input"
                        v-model="tableSearch"
                        size=""
                        placeholder="검색어를 입력해주세요."
              />
              <!--<el-button class="filter-item" type="primary" icon="el-icon-download" @click="handleDownload">
                엑셀 다운
              </el-button>-->
            </div>
            <el-table
              :data="tableFilter.slice(pagnation.size * (page - 1 ), pagnation.size * page)"
              style="width: 100%"
              empty-text="데이터가 없습니다."
            >
              <el-table-column
                class="table_no"
                type="index"
                label="번호"
                width="100"
                class-name="num"
                :index="tableIndex"
              >
              </el-table-column>
              <el-table-column v-for="header in tableHeader" :key="header.prop"
                               :label = header.label
                               :prop = header.prop
                               :width = header.width
                               sortable
                               :class-name = header.prop
              ></el-table-column>
              <el-table-column label="파일">
                <template slot-scope="scope">
                  <div v-if="scope.row.hasOwnProperty('File')">
                    <span v-for="file in scope.row.File" :key="file.a_idx" style="margin: 0 5px;">
                      <img class="cursor" @click="openModal(file)" :src="file.thumb_url" alt="" v-if="!returnHasVeideo(file.org_name)" style="width : 200px; height : 200px;">
                      <span v-else>{{file.org_name}}</span>
                    </span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                               :label="'등록일'"
                               :prop="'created_at'"
                               :width="200"
                               sortable
                               :class-name="'created_at'"
              ></el-table-column>
              <el-table-column v-if="tableoption"
                               align="right"
                               width="200"
                               label="옵션"
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="handleEdit(scope.$index, scope.row)">수정</el-button>
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)">삭제</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagnation_wrap" v-show="filterPagnation.total">
            <el-pagination
              :page-size = filterPagnation.size
              :pager-count = filterPagnation.pagerCount
              layout="prev, pager, next"
              :current-page.sync = page
              :total="filterPagnation.total"
            >
            </el-pagination>
          </div>
        </div>
        <page-footer></page-footer>
      </div>
    </div>
    <el-dialog
      :visible.sync="modalVisible"
      custom-class="img_modal"
      >
      <img width="100%" :src="modalUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
  import VuxAlert from '@/mixins/vux-alert';
  import util from '@/mixins/util';

  export default {
    name: "Safety",
    components: {},
    mixins: [ VuxAlert ],
    data(){
      return{
        data : {},
        title: this.$route.meta.title,
        tableData: [],
        orgTableData : [],
        categoryData : [],
        tableSearch: '',
        tableHeader: [
          {
            label : '분류명',
            prop : 'e_name',
          },

          // {
          //   label: '파일',
          //   prop: 'file',
          //   width: ''
          // },

          // {
          //   label: '등록일',
          //   prop: 'created_at',
          //   width: '200'
          // }
        ],
        tableoption: true,
        pagnation: {
          size: 10,
          pagerCount: 11,
          page: 1,
        },
        page : 1,
        tableSelected: '',
        categorySelected : '',
        tableSelectOption: [
          {
            label: '분류명',
            value: 'e_name'
          }
        ],
        modalVisible: false,
        modalUrl: null,
      }
    },
    computed: {
      tableFilter() {
        return this.tableData.filter(data => !this.tableSearch || data[this.tableSelected].includes(this.tableSearch))
      },
      filterPagnation() {
        this.resetPage()
        return {
          size: 10,
          pagerCount: 11,
          total: this.tableFilter.length,
          page: 1
        }
      }
    },
    mounted() {
      this.getList();
    },

    methods: {
      addBtn(){
        this.$router.push('/examples/detail');
      },
      resetPage() {
        this.page = 1
      },
      async getList() {
        await this.$api.$examples.getExample().then( res => res.Data.Result).then(res => {
          this.orgTableData = res.List;
          this.tableData = res.List;
          this.categoryData = res.Category;

          util.each(this.tableData, (item, index, allItems) => {
            util.each(this.categoryData, (category, index2, allItems2) => {
              if(item.ca_name == category.bc_idx){
                item.category = category.bc_name;
              }
            });

          });


          this.tableSelected = this.tableSelectOption[0].value;
        })
      },
      handleEdit(index, row) {
        this.$router.push('/examples/detail/'+row.e_idx);
      },
      handleDelete(index, row) {
        let alertParams = {'element' : this , 'key' : row.e_idx };
        this.listDeleteAlert(alertParams);

      },
      dataDelete(key){
        let params = {'e_idx' : key}
        this.$api.$examples.deleteExample(params).then( res => res.Data.Result).then(res => {
          if(res.status === true){
            this.page = 1;
            let alertParams = {'element' : this  };
            this.deleteAlert(alertParams);
          }else{
            this.errorAlert(res.reason);
          }
        })
      },
      CategoryChange() {
        this.tableSearch = '';
        if(this.categorySelected ){
          this.tableData = this.$_.filter(this.orgTableData, this.$_.iteratee({ ca_name: this.categorySelected }));
        }else{
          this.tableData = this.orgTableData;
        }

      },
      tableIndex(index) {
        return index + this.pagnation.size * (this.page - 1) +1
      },
      returnHasVeideo(url) {
        if(url) {
          if(url.substr(url.length - 3) === 'mp4'){
            return true;
          }else{
            return false;
          }
        }else{
          return false;
        }
      },
      openModal(file) {
        if(this.returnHasVeideo(file.name)) {
          this.errorAlert('확대보기는 이미지파일만 가능합니다.')
          return false;
        }
        this.modalUrl = file.org_url;
        this.modalVisible = true;
      }
    }
  }
</script>
<style>

</style>
